angular.module('cvsApp').service('getSpecialtyConfigService', ['networkService', 'configManager',
    'getSpecialtyConfigModal', function (NS, CM, getSpecialtyConfigModal) {
        function getSpecialtyConfigService() {
            this.getSpecialtyConfig = function (callBackSuccess, configKeyReq) {
                var url = CM.getApiUrlWithApikeyAndAppName('Get_Specialty_Config', cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB') + "&serviceCors=True";
                if (url === "URL_ERROR") {

                } else {
                    // var plainUrl = CM.getPlainApiUrl(url);
                    //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                    var request = {
                        url: url,
                        header: {
                            "Content-Type": "application/xml"
                        },
                        data: getRequestBody(configKeyReq),
                        onSuccess: callBackSuccess
                    }
                    cvsUtility.commonServiceCode(url, "getSpecialtyConfig", getSpecialtyConfigModal, request, callBackSuccess, NS);
                }

            };

            var getRequestBody = function (configKeyReq) {
                var reqObj = {
                    "request": {
                        "apiKey": cvsUtility.queryMap.apikey,
                        "tokenId": cvsUtility.queryMap.tokenId,
                        "configurationRequest": {
                            configKey: configKeyReq ? configKeyReq : ["PAYMENT-PUB-KEY"]
                        }
                    }
                }
                var x2js = new X2JS();
                return x2js.json2xml_str(reqObj);
            };

        }

        return new getSpecialtyConfigService();
    }]);